// extracted by mini-css-extract-plugin
module.exports = {"roleAutocomplete":"roleAutocomplete--a0Aqvf6bSGpJ583tRMB4"};